module.exports = __webpack_public_path__ + "static/ahmad-f9e5c78f36ad19fdc54d79271fdbddc4.webm";